import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import TituloComponent from '../../components/Titulo/TituloComponent';
// css
import '../../styles/global.css';
import './GerarQrCodeMesa.css';
import GerarQrCodeMesaComponent from '../../components/GerarQrCodeMesaComponent/GerarQrCodeMesaComponent';

const GerarQrCodeMesa = () => {
  const navigate = useNavigate();
  
  // Pega os dados da sessão diretamente
  const userData = JSON.parse(sessionStorage.getItem('userData')); // Assume que os dados estão armazenados no sessionStorage

  const [formData, setFormData] = useState({
      numeroMesa: "",
  });

  const [qrCodeUrl, setQrCodeUrl] = useState('');
  const qrCodeRef = useRef(null);

    useEffect(() => {
      console.log('Entrou em GerarQrCodeMesa...');
      console.log('Verificando status do usuário na sessão...');
      if (userData) {
          try {
              if (userData.statusUsuario === 'logado') {
                  console.log('Dados do usuário na sessão:', userData);
                  const idEstabelecimento = userData.dadosEstabelecimento.id;

                  console.log('Dados do estabelecimento: ');
                  console.log(userData.dadosEstabelecimento);

              } else {
                  console.log('Usuário não está logado.');
              }
          } catch (error) {
              console.error('Erro ao parsear os dados de usuário:', error);
          }
      } else {
          console.log('Usuário NÃO está logado!');
      }
  }, [navigate]);

  const handleSubmit = (e) => {
    console.log('Entrou no handleSubmit do GerarQrCodeMesa...');

    e.preventDefault();
    const numeroMesa = formData.numeroMesa;
  
    // Aqui você define a URL que será codificada no QR Code
    // const url = `${window.location.origin}/checkin-mesa/${numeroMesa}`;
    const url = `/atualizar-checkin-qrcodemesa/${numeroMesa}`;    
  
    console.log('URL do QR Code:', url);
    setQrCodeUrl(url);
  };
  
  return (
    <div autoFocus className="bar-gerente-container">
        <TituloComponent />
        <form onSubmit={handleSubmit}>
          <h2 className="form-title">Gerar QR Code</h2>

          <div className="box-dados">
              <p className="texto-welcome">Você está em { userData.dadosEstabelecimento.nome }!</p>
          </div>

          <GerarQrCodeMesaComponent />

        </form>

    </div>
  );
};

export default GerarQrCodeMesa;
